import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.map.get-or-insert.js";
import "core-js/modules/esnext.map.get-or-insert-computed.js";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch, Emit } from 'vue-facing-decorator';
import WRadioGroup from "@/components/form/w-radio-group.vue";
import WSelectUsers from "@/components/form/w-select-users.vue";
import WSelect from "@/components/form/w-select.vue";
import UserCell from "@/components/user/UserCell.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { Events } from "@/events/events";
import WToolTip from "@/components/tooltip/w-toolTip.vue";
import IconButton from "@/components/buttons/IconButton.vue";
let AnonymousWorkflowSubmit = class AnonymousWorkflowSubmit extends Vue {
  constructor(...args) {
    super(...args);
    // Used to trigger the event for when the component was used in a legacy HTML template
    _defineProperty(this, "legacyMode", void 0);
    _defineProperty(this, "existingApprovers", void 0);
    _defineProperty(this, "isPeriodic", void 0);
    // Local UI state
    _defineProperty(this, "approvers", []);
    // Drag-and-drop state
    _defineProperty(this, "dragStartIndex", null);
    _defineProperty(this, "dragOverIndex", null);
    // Role editor state
    _defineProperty(this, "roleEditorValue", '');
    _defineProperty(this, "popoverRefs", new Map());
    _defineProperty(this, "roleInputRefs", new Map());
    _defineProperty(this, "updatingOrders", false);
  }
  mounted() {
    if (this.existingApprovers) {
      this.approvers = this.existingApprovers;
    }
    this.syncOrders();
    this.emitChange();
  }
  onApproversChanged() {
    if (!this.updatingOrders) {
      this.syncOrders();
      this.emitChange();
    }
  }
  emitChange() {
    const approversJson = JSON.stringify((this.approvers || []).map(a => ({
      id: a.id,
      label: a.label,
      email: a.email,
      role: a.role,
      order: a.order
    })));
    this.$emit('approversUpdated', approversJson);
    if (this.legacyMode) {
      trig(Events.ANONYMOUS_APPROVERS_UPDATED, approversJson);
    }
  }
  // Keep the "order" attribute consistent with the list position
  syncOrders() {
    this.updatingOrders = true;
    (this.approvers || []).forEach((u, i) => {
      if (u) u.order = i + 1;
    });
    // release the guard on next tick so watcher triggered by property updates won't recurse
    this.$nextTick(() => {
      this.updatingOrders = false;
    });
  }
  onDragStart(index) {
    this.dragStartIndex = index;
    this.dragOverIndex = index;
  }
  onDragEnter(index) {
    this.dragOverIndex = index;
  }
  onDrop(index) {
    if (this.dragStartIndex === null) return;
    const from = this.dragStartIndex;
    const to = index;
    if (from !== to) {
      const moved = this.approvers[from];
      const remaining = this.approvers.filter((_, i) => i !== from);
      remaining.splice(to, 0, moved);
      this.approvers = remaining;
      this.syncOrders();
      this.$nextTick(() => this.emitChange());
    }
    this.onDragEnd();
  }
  onDragEnd() {
    this.dragStartIndex = null;
    this.dragOverIndex = null;
  }
  // Remove an approver
  removeApprover(index) {
    this.approvers.splice(index, 1);
    this.syncOrders();
    this.emitChange();
  }
  toUser(u) {
    const label = (u.label || '').trim();
    const [first, ...rest] = label.split(/\s+/);
    const last = rest.join(' ');
    return {
      id: u.id,
      firstName: first || '',
      lastName: last || '',
      email: u.email || '',
      img: u.imgUrl || ''
    };
  }
  setPopoverRef(index) {
    // return a function that Vue calls with the component instance
    return inst => {
      if (inst) this.popoverRefs.set(index, inst);else this.popoverRefs.delete(index);
    };
  }
  onPopoverShow(index) {
    this.$nextTick(() => {
      const elInput = this.roleInputRefs.get(index);
      if (elInput?.focus) {
        elInput.focus(); // ElInput instance method
      } else {
        // Fallback to native input inside the component
        const native = elInput?.$el?.querySelector('input');
        native?.focus();
      }
    });
  }
  setRoleInputRef(index) {
    return inst => {
      if (inst) this.roleInputRefs.set(index, inst);else this.roleInputRefs.delete(index);
    };
  }
  prepareRoleEditor(currentRole) {
    this.roleEditorValue = currentRole;
  }
  saveRole(index) {
    const trimmed = (this.roleEditorValue || '').trim();
    const updated = [...this.approvers];
    updated[index] = {
      ...updated[index],
      role: trimmed || undefined
    };
    this.approvers = updated;
    // Close the popover using the official instance method
    const pop = this.popoverRefs.get(index);
    if (pop?.hide) pop.hide();
    this.roleEditorValue = '';
    this.$nextTick(() => this.emitChange());
  }
};
__decorate([Prop({
  default: false
})], AnonymousWorkflowSubmit.prototype, "legacyMode", void 0);
__decorate([Prop({
  default: undefined
})], AnonymousWorkflowSubmit.prototype, "existingApprovers", void 0);
__decorate([Prop({
  default: false
})], AnonymousWorkflowSubmit.prototype, "isPeriodic", void 0);
__decorate([Watch('approvers', {
  deep: true
})], AnonymousWorkflowSubmit.prototype, "onApproversChanged", null);
__decorate([Emit()], AnonymousWorkflowSubmit.prototype, "emitChange", null);
AnonymousWorkflowSubmit = __decorate([Component({
  components: {
    IconButton,
    WToolTip,
    StandardButton,
    UserCell,
    WRadioGroup,
    WSelectUsers,
    WSelect
  },
  emits: ['approversUpdated']
})], AnonymousWorkflowSubmit);
export default AnonymousWorkflowSubmit;